import(/* webpackMode: "eager" */ "/app/src/app/[locale]/downloads/error.tsx");
